function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M240 0H0V160H240V0ZM120 98C129.941 98 138 89.9411 138 80C138 70.0589 129.941 62 120 62C110.059 62 102 70.0589 102 80C102 89.9411 110.059 98 120 98Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1007_4470)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector 14",
  d: "M121.5 73C122 53.8333 133.2 21.9 178 19.5",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 12",
  d: "M121 83C127.167 74 147.4 53.5 181 53.5",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 15",
  d: "M120.5 80.5C106.5 80.5 47 93 30 145.5",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 25",
  d: "M120.5 80.5C97 47.5 73.5 24 28 21",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 17",
  d: "M122 83.5L182.5 143",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 18",
  d: "M46 78.5H120",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 21",
  d: "M93.4973 124.5L123 74.5",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "6 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 23",
  d: "M95.9999 20.5L120.525 80",
  stroke: "#003F7A",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "6 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 20",
  d: "M126.5 79.5H171",
  stroke: "#0067C5",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0.1 8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 22",
  d: "M101 72L68.5 57",
  stroke: "#003F7A",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "6 6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 24",
  d: "M121.5 99V125.5",
  stroke: "#003F7A",
  strokeWidth: 3,
  strokeMiterlimit: 2.3662,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "6 6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 1",
  d: "M31.3413 5.50218C31.9746 4.96753 32.9461 5.39118 32.9852 6.21909L33.4291 15.6098C33.4447 15.9386 33.621 16.2387 33.9006 16.4122L41.8882 21.3703C42.5924 21.8074 42.4896 22.8623 41.7143 23.1553L32.9204 26.4794C32.6125 26.5958 32.3816 26.8562 32.303 27.1758L30.0558 36.3045C29.8577 37.1093 28.8228 37.3376 28.3045 36.6908L22.4256 29.3545C22.2198 29.0976 21.9008 28.9585 21.5725 28.9825L12.1962 29.6663C11.3695 29.7265 10.8326 28.8128 11.2876 28.12L16.4482 20.2618C16.6288 19.9867 16.6626 19.6403 16.5384 19.3355L12.9906 10.6294C12.6778 9.86181 13.3809 9.06879 14.1804 9.2874L23.2487 11.7671C23.5662 11.8539 23.9061 11.779 24.1576 11.5666L31.3413 5.50218Z",
  fill: "#47A6FF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 2",
  d: "M206.991 40.6448C207.153 39.832 208.176 39.5577 208.723 40.1806L214.924 47.2469C215.141 47.4943 215.466 47.6191 215.793 47.5805L225.129 46.4784C225.952 46.3812 226.53 47.2701 226.106 47.9825L221.302 56.0635C221.134 56.3464 221.115 56.6939 221.253 56.9929L225.186 65.5317C225.533 66.2845 224.866 67.1082 224.058 66.9255L214.888 64.8535C214.567 64.781 214.23 64.8711 213.989 65.0944L207.083 71.4738C206.474 72.0363 205.485 71.6564 205.409 70.8311L204.546 61.4696C204.515 61.1418 204.326 60.85 204.039 60.6891L195.838 56.0929C195.115 55.6877 195.17 54.6293 195.932 54.3019L204.568 50.5881C204.87 50.4581 205.09 50.1876 205.154 49.8648L206.991 40.6448Z",
  fill: "#007EF5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 2_2",
  d: "M100.443 118.013C101.258 117.865 101.889 118.716 101.511 119.454L99.0366 124.272C98.8863 124.565 98.8896 124.913 99.0456 125.203L101.613 129.973C102.005 130.703 101.391 131.566 100.573 131.434L95.2251 130.57C94.9001 130.518 94.5702 130.628 94.3427 130.866L90.5995 134.782C90.0267 135.381 89.0156 135.063 88.8885 134.244L88.0577 128.891C88.0072 128.566 87.7999 128.287 87.5034 128.144L82.6229 125.794C81.8761 125.434 81.8659 124.374 82.6055 124L87.4396 121.556C87.7333 121.407 87.9351 121.124 87.9793 120.798L88.7063 115.43C88.8175 114.609 89.8222 114.271 90.4065 114.859L94.2249 118.701C94.4569 118.935 94.7889 119.039 95.1128 118.98L100.443 118.013Z",
  fill: "#47A6FF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 3",
  d: "M171.301 72.0162C171.668 71.273 172.728 71.273 173.094 72.0162L174.316 74.4917C174.462 74.7869 174.743 74.9914 175.069 75.0388L177.801 75.4357C178.621 75.5549 178.949 76.5629 178.355 77.1414L176.378 79.0683C176.143 79.2981 176.035 79.6291 176.091 79.9535L176.558 82.6743C176.698 83.4912 175.84 84.1142 175.107 83.7285L172.663 82.4439C172.372 82.2907 172.024 82.2907 171.732 82.4439L169.289 83.7285C168.555 84.1142 167.698 83.4912 167.838 82.6743L168.305 79.9535C168.36 79.6291 168.253 79.2981 168.017 79.0683L166.04 77.1414C165.447 76.5629 165.774 75.5549 166.594 75.4357L169.326 75.0388C169.652 74.9914 169.934 74.7869 170.079 74.4917L171.301 72.0162Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 4",
  d: "M44.1033 71.0162C44.4701 70.273 45.5299 70.273 45.8967 71.0162L47.1185 73.4917C47.2641 73.7869 47.5457 73.9914 47.8714 74.0388L50.6033 74.4357C51.4235 74.5549 51.751 75.5629 51.1575 76.1414L49.1807 78.0683C48.945 78.2981 48.8375 78.6291 48.8931 78.9535L49.3598 81.6743C49.4999 82.4912 48.6424 83.1142 47.9088 82.7285L45.4653 81.4439C45.174 81.2907 44.826 81.2907 44.5347 81.4439L42.0912 82.7285C41.3576 83.1142 40.5001 82.4912 40.6402 81.6743L41.1069 78.9535C41.1625 78.6291 41.055 78.2981 40.8193 78.0683L38.8425 76.1414C38.249 75.5629 38.5765 74.5549 39.3967 74.4357L42.1286 74.0388C42.4543 73.9914 42.7359 73.7869 42.8815 73.4917L44.1033 71.0162Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 6",
  d: "M194.103 6.81698C194.47 6.07374 195.53 6.07374 195.897 6.81699L197.118 9.29249C197.264 9.58763 197.546 9.7922 197.871 9.83953L200.603 10.2365C201.424 10.3557 201.751 11.3637 201.158 11.9422L199.181 13.8691C198.945 14.0988 198.837 14.4298 198.893 14.7542L199.36 17.4751C199.5 18.292 198.642 18.9149 197.909 18.5293L195.465 17.2446C195.174 17.0915 194.826 17.0915 194.535 17.2446L192.091 18.5293C191.358 18.9149 190.5 18.292 190.64 17.4751L191.107 14.7542C191.163 14.4298 191.055 14.0988 190.819 13.8691L188.842 11.9422C188.249 11.3637 188.576 10.3557 189.397 10.2365L192.129 9.83953C192.454 9.7922 192.736 9.58763 192.882 9.29249L194.103 6.81698Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 7",
  d: "M182.103 137.817C182.47 137.074 183.53 137.074 183.897 137.817L185.118 140.292C185.264 140.588 185.546 140.792 185.871 140.84L188.603 141.236C189.424 141.356 189.751 142.364 189.158 142.942L187.181 144.869C186.945 145.099 186.837 145.43 186.893 145.754L187.36 148.475C187.5 149.292 186.642 149.915 185.909 149.529L183.465 148.245C183.174 148.091 182.826 148.091 182.535 148.245L180.091 149.529C179.358 149.915 178.5 149.292 178.64 148.475L179.107 145.754C179.163 145.43 179.055 145.099 178.819 144.869L176.842 142.942C176.249 142.364 176.576 141.356 177.397 141.236L180.129 140.84C180.454 140.792 180.736 140.588 180.882 140.292L182.103 137.817Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 8",
  d: "M29.1033 139.817C29.4701 139.074 30.5299 139.074 30.8967 139.817L32.1185 142.292C32.2641 142.588 32.5457 142.792 32.8714 142.84L35.6033 143.236C36.4235 143.356 36.751 144.364 36.1575 144.942L34.1807 146.869C33.945 147.099 33.8375 147.43 33.8931 147.754L34.3598 150.475C34.4999 151.292 33.6424 151.915 32.9088 151.529L30.4653 150.245C30.174 150.091 29.826 150.091 29.5347 150.245L27.0912 151.529C26.3576 151.915 25.5001 151.292 25.6402 150.475L26.1069 147.754C26.1625 147.43 26.055 147.099 25.8193 146.869L23.8425 144.942C23.249 144.364 23.5765 143.356 24.3967 143.236L27.1286 142.84C27.4543 142.792 27.7359 142.588 27.8815 142.292L29.1033 139.817Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Star 5",
  d: "M95.1033 14.817C95.4701 14.0737 96.5299 14.0737 96.8967 14.817L98.1185 17.2925C98.2641 17.5876 98.5457 17.7922 98.8714 17.8395L101.603 18.2365C102.424 18.3557 102.751 19.3637 102.158 19.9422L100.181 21.8691C99.945 22.0988 99.8375 22.4298 99.8931 22.7542L100.36 25.4751C100.5 26.292 99.6424 26.9149 98.9088 26.5293L96.4653 25.2446C96.174 25.0915 95.826 25.0915 95.5347 25.2446L93.0912 26.5293C92.3576 26.9149 91.5001 26.292 91.6402 25.4751L92.1069 22.7542C92.1625 22.4298 92.055 22.0988 91.8193 21.8691L89.8425 19.9422C89.249 19.3637 89.5765 18.3557 90.3967 18.2365L93.1286 17.8395C93.4543 17.7922 93.7359 17.5876 93.8815 17.2925L95.1033 14.817Z",
  fill: "#70BAFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 19",
  cx: 121,
  cy: 38,
  r: 4,
  fill: "#C2E1FF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 20",
  cx: 152,
  cy: 10,
  r: 4,
  fill: "#D6EBFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 24",
  cx: 221,
  cy: 29,
  r: 4,
  fill: "#D6EBFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 25",
  cx: 21,
  cy: 102,
  r: 4,
  fill: "#EBF5FF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 26",
  cx: 218,
  cy: 137,
  r: 4,
  fill: "#EBF5FF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 23",
  cx: 137,
  cy: 138,
  r: 4,
  fill: "#D6EBFF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 21",
  cx: 184,
  cy: 110,
  r: 6,
  fill: "#C2E1FF"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 22",
  cx: 68,
  cy: 57,
  r: 6,
  fill: "#C2E1FF"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1007_4470"
}, /*#__PURE__*/React.createElement("rect", {
  width: 240,
  height: 160,
  fill: "white"
})));

function SvgFireWorks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 160,
    viewBox: "0 0 240 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "FireWorks",
    clipPath: "url(#clip0_1007_4470)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_4470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 160
  }, _ref2), _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireWorks);
export default __webpack_public_path__ + "static/media/FireWorks.256d7812942476698624e84d5cfb6f04.svg";
export { ForwardRef as ReactComponent };